import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // ニュースレター登録処理
    setEmail('');
  };

  return (
    <footer className="bg-gradient-to-br from-orange-100 via-pink-50 to-amber-100 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 mb-12">
          {/* 左側エリア */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/5e5f957ef398d7b7e688123f7d43a515/6af3d63b7347a7162ba15b1cbc9a002c.jpeg" 
                alt="まごころサービス ロゴ" 
                className="w-12 h-12 object-contain"
              />
              <h4 className="text-2xl font-bold text-gray-800" style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}>
                まごころサービス
              </h4>
            </div>
            <p className="text-sm text-gray-600 mb-8 leading-relaxed font-light" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              私たちは、あなたの毎日に寄り添います。介護保険外サービスでも、変わらぬ安心と笑顔をお届けします。
            </p>

            {/* ニュースレター */}
            <div>
              <p className="text-sm font-medium text-gray-700 mb-3" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                最新情報をお届けします
              </p>
              <form onSubmit={handleNewsletterSubmit} className="flex flex-col gap-3">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="メールアドレスを入力"
                  className="px-4 py-2 bg-white/80 border-b-2 border-gray-300 focus:border-orange-400 focus:outline-none text-sm"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                />
                <button
                  type="submit"
                  className="self-start px-6 py-2 border-2 border-gray-700 rounded-full text-sm font-medium text-gray-700 hover:bg-gray-700 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                >
                  登録する
                </button>
              </form>
            </div>
          </div>

          {/* 右側ナビゲーションエリア */}
          <div className="md:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-8">
            {/* 第1カラム */}
            <div>
              <h5 className="text-base font-bold text-gray-800 mb-4" style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}>
                サービス案内
              </h5>
              <ul className="space-y-3">
                <li>
                  <a href="#services" className="text-sm text-gray-600 hover:text-orange-500 transition-colors font-light cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    日常生活支援
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-sm text-gray-600 hover:text-orange-500 transition-colors font-light cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    心のケア
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-sm text-gray-600 hover:text-orange-500 transition-colors font-light cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    家事援助
                  </a>
                </li>
              </ul>
            </div>

            {/* 第2カラム */}
            <div>
              <h5 className="text-base font-bold text-gray-800 mb-4" style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}>
                会社情報
              </h5>
              <ul className="space-y-3">
                <li>
                  <a href="#philosophy" className="text-sm text-gray-600 hover:text-orange-500 transition-colors font-light cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    私たちについて
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-gray-600 hover:text-orange-500 transition-colors font-light cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    採用情報
                  </a>
                </li>
              </ul>
            </div>

            {/* 第3カラム */}
            <div>
              <h5 className="text-base font-bold text-gray-800 mb-4" style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}>
                お問い合わせ
              </h5>
              <ul className="space-y-3">
                <li>
                  <a href="#contact" className="text-sm text-gray-600 hover:text-orange-500 transition-colors font-light cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    無料相談
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-gray-600 hover:text-orange-500 transition-colors font-light cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    よくある質問
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-gray-600 hover:text-orange-500 transition-colors font-light cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    プライバシーポリシー
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* ボトムエリア */}
        <div className="pt-8 border-t border-orange-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-600 font-light" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            &copy; 2025 まごころサービス. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="nofollow noopener noreferrer" 
            className="text-sm text-gray-500 hover:text-orange-500 transition-colors font-light cursor-pointer"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
